<template>
  <div>
    <b-card no-body>
      <b-card-header>
        <b-card-title>Data</b-card-title>
      </b-card-header>

      <b-card-body>
        <b-row>
          <b-col cols="8" offset-md="2">
            <h4>Filter</h4>
            <b-form class="needs-validation" @submit.prevent="submitFilter">
              <b-row>
                <b-col cols="6">
                  <b-form-group label="Tahun" label-for="tahunFilter">
                    <b-form-select
                      v-model="tahunFilter"
                      id="tahunFilter"
                      :options="dataTahun"
                      disabled
                    />
                  </b-form-group>
                </b-col>
                <!-- <b-col cols="6">
                  <b-form-group label="Bulan" label-for="bulanFilter">
                    <b-form-select
                      v-model="bulanFilter"
                      id="bulanFilter"
                      :options="dataBulan"
                    />
                  </b-form-group>
                </b-col> -->
                <b-col cols="6">
                  <b-form-group label="KIB" label-for="kibFilter">
                    <b-form-select
                      v-model="kibFilter"
                      id="kibFilter"
                      :options="dataKib"
                      disabled
                    />
                  </b-form-group>
                </b-col>
                <b-col cols="6">
                  <b-form-group label="Wilayah" label-for="wilayahFilter">
                    <b-form-select
                      v-model="wilayahFilter"
                      id="wilayahFilter"
                      :options="dataWilayah"
                      @change="changeWilayah"
                      :disabled="!$can('Filter', 'validasiBelumTercatat')"
                    />
                  </b-form-group>
                </b-col>

                <b-col cols="6">
                  <b-form-group label="PD/UPD" label-for="pdUpdFilter">
                    <v-select
                      id="kolok"
                      v-model="pdUpdFilterValue"
                      label="text"
                      :options="dataPdUpd"
                      @search="searchPdUpd"
                      @input="inputPdUpd"
                      :disabled="
                        !$can('Filter', 'validasiBelumTercatat') &&
                        !$can('Filter-PdUpd', 'validasiBelumTercatat')
                      "
                    />
                  </b-form-group>
                </b-col>
                <b-col cols="6">
                  <b-form-group label="Keberadaan" label-for="keberadaanFilter">
                    <b-form-select
                      v-model="keberadaanFilter"
                      id="keberadaanFilter"
                      :options="dataKeberadaan"
                    />
                  </b-form-group>
                </b-col>
                <b-col cols="6">
                  <b-form-group label="Status" label-for="statusFilter">
                    <b-form-select
                      v-model="statusFilter"
                      id="statusFilter"
                      :options="dataStatus"
                    />
                  </b-form-group>
                </b-col>
              </b-row>
              <b-col cols="12" align="right" class="pr-0">
                <b-button
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  variant="primary"
                  size="sm"
                  type="submit"
                >
                  Filter
                </b-button>
              </b-col>
            </b-form>
          </b-col>
          <b-col cols="12" class="mt-2">
            <!-- search input -->
            <div class="custom-search d-flex justify-content-end">
              <b-form-group>
                <div class="d-flex align-items-center">
                  <label class="mr-1">Cari</label>
                  <b-form-input
                    v-model="searchTerm"
                    placeholder="Tekan Enter"
                    type="text"
                    class="d-inline-block"
                    @keyup.enter="handleSearch"
                  />
                </div>
              </b-form-group>
            </div>
            <!-- table -->
            <vue-good-table
              :columns="columns"
              :rows="rows"
              :search-options="{
                enabled: true,
                externalQuery: searchTerm,
              }"
              :pagination-options="{
                enabled: true,
                perPage: row,
                jumpFirstOrLast: true,
              }"
              :totalRows="totalRecords"
              :isLoading.sync="isLoading"
              mode="remote"
              @on-sort-change="onSortChange"
            >
              <template slot="table-row" slot-scope="props">
                <!-- Column: aksi -->
                <span v-if="props.column.field === 'aksi'">
                  <span>
                    <b-dropdown
                      variant="link"
                      toggle-class="text-decoration-none"
                      no-caret
                    >
                      <template v-slot:button-content>
                        <feather-icon
                          icon="MoreVerticalIcon"
                          size="16"
                          class="text-body align-middle mr-25"
                        />
                      </template>
                      <b-dropdown-item
                        :to="{
                          name: 'validasiBelumTercatatValidasi',
                          params: { id: props.row.id.toString() },
                        }"
                        v-if="
                          props.row.status == 10 &&
                          $can('Validasi', 'validasiBelumTercatat')
                        "
                      >
                        <feather-icon icon="Edit2Icon" class="mr-50" />
                        <span>Validasi</span>
                      </b-dropdown-item>
                      <b-dropdown-item
                        :to="{
                          name: 'validasiBelumTercatatDetail',
                          params: { id: props.row.id.toString() },
                        }"
                        v-if="
                          (props.row.status == 10 ||
                            props.row.status == 11 ||
                            props.row.status == 12) &&
                          $can('Detail', 'validasiBelumTercatat')
                        "
                      >
                        <feather-icon icon="Edit2Icon" class="mr-50" />
                        <span>Detail</span>
                      </b-dropdown-item>
                    </b-dropdown>
                  </span>
                </span>
                <span v-else-if="props.column.field === 'kobar_108'">
                  {{ props.row.kobar_108 }}
                  <br />
                  Noreg: {{ props.row.noreg_108 }}
                </span>
                <span v-else-if="props.column.field === 'status'">
                  Status :
                  <b-badge
                    variant="light-secondary"
                    v-if="props.row.status == 10"
                  >
                    Menunggu Validasi BMD Belum Tercatat
                  </b-badge>
                  <b-badge
                    variant="light-danger"
                    v-else-if="props.row.status == 11"
                  >
                    Dikembalikan BMD Belum Tercatat
                  </b-badge>
                  <b-badge
                    variant="light-success"
                    v-else-if="props.row.status == 12"
                  >
                    Disetujui BMD Belum Tercatat
                  </b-badge>
                  <br />

                  <div v-if="props.row.keberadaan">
                    Keberadaan :
                    <b-badge
                      variant="light-secondary"
                      v-if="props.row.keberadaan == 0"
                    >
                      Tidak Ada
                    </b-badge>
                    <b-badge
                      variant="light-success"
                      v-else-if="props.row.keberadaan == 1"
                    >
                      Ada
                    </b-badge>
                    <br />
                  </div>
                  <div v-if="props.row.wujud_bmd">
                    Biaya/Beban :
                    <b-badge
                      variant="light-secondary"
                      v-if="props.row.wujud_bmd == 0"
                    >
                      Bukan
                    </b-badge>
                    <b-badge
                      variant="light-success"
                      v-else-if="props.row.wujud_bmd == 1"
                    >
                      Iya
                    </b-badge>
                  </div>
                </span>

                <!-- Column: Common -->
                <span v-else>
                  {{ props.formattedRow[props.column.field] }}
                </span>
              </template>

              <!-- pagination -->
              <template slot="pagination-bottom">
                <div class="d-flex justify-content-between flex-wrap">
                  <div class="d-flex align-items-center mb-0 mt-1">
                    <span class="text-nowrap"> Menampilkan 1 hingga </span>
                    <b-form-select
                      v-model="row"
                      :options="['10','25','50']"
                      class="mx-1"
                      @input="handlePageChange"
                    />
                    <span class="text-nowrap">
                      dari {{ totalRecords }} entri
                    </span>
                  </div>
                  <div>
                    <b-pagination
                      :value="1"
                      :total-rows="totalRecords"
                      :per-page="row"
                      first-number
                      last-number
                      align="right"
                      prev-class="prev-item"
                      next-class="next-item"
                      class="mt-1 mb-0"
                      @change="handleChangePage"
                    >
                      <template #prev-text>
                        <feather-icon icon="ChevronLeftIcon" size="18" />
                      </template>
                      <template #next-text>
                        <feather-icon icon="ChevronRightIcon" size="18" />
                      </template>
                    </b-pagination>
                  </div>
                </div>
              </template>
            </vue-good-table>
          </b-col>
        </b-row>
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BCard,
  BCardText,
  BFormInput,
  BAvatar,
  BBadge,
  BDropdown,
  BDropdownItem,
  BPagination,
  BCardHeader,
  BCardTitle,
  BCardBody,
  BButton,
  BFormGroup,
  BFormSelect,
  BForm,
} from "bootstrap-vue";
import { VueGoodTable } from "vue-good-table";
import Ripple from "vue-ripple-directive";
import { ref, onUpdated, computed, watch } from "@vue/composition-api";
// import {encrypt, decrypt} from '@/libs/crypto'
const moment = require("moment");
import { generateYears, startYear, generateMonths } from "@/libs/helper";
import master from "@/composables/master";
import vSelect from "vue-select";
import cetakDaftarBmd from "@/composables/cetakDaftarBmd";

export default {
  setup(props, context) {
    //global variable
    const g = context.root;
    const $http = g.$http;
    const $route = g.$route;

    var year = moment().format("YYYY");
    var month = moment().format("M");

    var tahunFilter = ref($route.query.tahun || year);
    var bulanFilter = ref($route.query.bulan || month);
    var pdUpdFilter = ref($route.query["pd-upd"] || "");
    var pdUpdFilterValue = ref({ text: "-- Semua --", value: "" });
    var kibFilter = ref($route.query.kib || "C");
    var wilayahFilter = ref($route.query.wilayah || "");
    var keberadaanFilter = ref($route.query.keberadaan || "");
    var statusFilter = ref($route.query.status || "10");

    var cookiesJenisAkun = ref(g.$cookies.get("jenisAkun"));

    if (cookiesJenisAkun.value == "D" || cookiesJenisAkun.value == "F") {
      var cookiesNalok = ref(g.$cookies.get("nalok"));
      var cookiesKolok = ref(g.$cookies.get("kolok"));
      var cookiesWilayah = ref(g.$cookies.get("wilayah"));
      pdUpdFilterValue.value = {
        text: `${cookiesKolok.value}::${cookiesNalok.value}`,
        value: cookiesKolok.value,
      };
      pdUpdFilter.value = cookiesKolok.value;
      wilayahFilter.value = cookiesWilayah.value;
    } else if (cookiesJenisAkun.value == "pelaksana-suban")
      wilayahFilter.value = parseInt(g.$cookies.get("wilayah"));

    var dataTahun = ref(generateYears(startYear, year));
    var dataBulan = ref(generateMonths());
    var dataPdUpd = ref([{ text: "-- Semua --", value: "" }]);
    var dataKib = ref([{ text: "-- Semua --", value: "" }]);
    var dataProvinsi = ref([]);
    var dataWilayah = ref([]);
    var dataKecamatan = ref([]);
    var dataKelurahan = ref([]);
    var dataKeberadaan = ref([
      { value: "", text: "-- Semua --" },
      { value: "1", text: "Ada" },
      { value: "0", text: "Tidak Ada" },
    ]);
    var dataStatus = ref([]);

    //variable untuk table
    let rows = ref([]);
    let searchTerm = ref("");
    let start = ref(1);
    let row = ref(10);
    let totalRecords = ref(0);
    let sortColumn = ref("");
    let order = ref("");
    let isLoading = ref(false);

    //fungsi ambil data untuk table
    const datatable = async () => {
      isLoading.value = true;

      let params = {
        filter_kib: kibFilter.value,
        filter_tahun: tahunFilter.value,
        filter_upd: pdUpdFilter.value,
        kode_wilayah: wilayahFilter.value,
        filter_status: statusFilter.value,
        length: row.value,
        start: start.value - 1,
        cari: searchTerm.value,
        list: "unfound",
      };
      let resBmd = await cetakDaftarBmd.getBmd(g, params);
      const { code, list, totalList } = resBmd;

      if (code == 200) {
        rows.value = list;
        totalRecords.value = totalList;
      } else {
        rows.value = [];
        totalRecords.value = 0;
      }

      isLoading.value = false;
    };

    datatable();

    const submitFilter = () => {
      let url = `?wilayah=${wilayahFilter.value}&status=${statusFilter.value}&kib=${kibFilter.value}&tahun=${tahunFilter.value}`;
      window.history.pushState("", "", url);
      start.value = 1;
      datatable();
    };

    const handleSearch = (searching) => {
      start.value = 1;
      datatable();
    };

    const handlePageChange = (active) => {
      start.value = 1;
      datatable();
    };

    const handleChangePage = (page) => {
      start.value = (page - 1) * row.value + 1;
      datatable();
    };

    const onSortChange = (params) => {
      sortColumn.value = params[0].field;
      order.value = params[0].type;
      datatable();
    };

    const getWilayah = async () => {
      let resWilayah = await master.getWilayah(g);
      resWilayah.unshift({ text: "-- Semua --", value: "" });

      dataWilayah.value = resWilayah;
    };

    const getKib = async () => {
      let resKib = await master.getKib(g);
      resKib.unshift({ text: "-- Pilih Salah Satu --", value: "" });
      dataKib.value = resKib;
    };

    const getPdUpd = async (searchPdUpd = "") => {
      let params = {
        tahun: tahunFilter.value,
        cari: searchPdUpd,
        wilayah: wilayahFilter.value,
      };
      let resPdUpd = await master.getPdUpd(g, params);
      resPdUpd.unshift({ text: "-- Semua --", value: "" });
      dataPdUpd.value = resPdUpd;
    };
    getPdUpd();

    const getStatus = async () => {
      let params = {
        list: "unfound",
      };
      let resStatus = await master.getStatus(g, params);

      dataStatus.value = resStatus.data;
    };

    const searchPdUpd = async (search) => {
      getPdUpd(search);
    };

    const changeWilayah = () => {
      if (wilayahFilter.value) {
        pdUpdFilter.value = "";
        pdUpdFilterValue.value = { text: "-- Semua --", value: "" };
      }
      getPdUpd();
    };

    const inputPdUpd = () => {
      if (pdUpdFilterValue.value)
        pdUpdFilter.value = pdUpdFilterValue.value.value;
    };

    getKib();
    getWilayah();
    getStatus();

    return {
      datatable,
      handleSearch,
      handlePageChange,
      handleChangePage,
      onSortChange,
      changeWilayah,
      inputPdUpd,
      searchPdUpd,
      submitFilter,
      rows,
      searchTerm,
      start,
      row,
      totalRecords,
      sortColumn,
      order,
      isLoading,
      tahunFilter,
      pdUpdFilter,
      kibFilter,
      wilayahFilter,
      bulanFilter,
      keberadaanFilter,
      statusFilter,
      pdUpdFilterValue,
      dataTahun,
      dataPdUpd,
      dataKib,
      dataProvinsi,
      dataWilayah,
      dataKecamatan,
      dataKelurahan,
      dataBulan,
      dataKeberadaan,
      dataStatus,
    };
  },
  components: {
    VueGoodTable,
    vSelect,
    BRow,
    BCol,
    BCard,
    BCardText,
    BFormInput,
    BAvatar,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BCardHeader,
    BCardTitle,
    BCardBody,
    BButton,
    BFormGroup,
    BFormSelect,
    BForm,
  },
  data() {
    return {
      columns: [
        {
          label: "Aksi",
          field: "aksi",
          width: "1%",
          sortable: false,
        },
        {
          label: "Guid ID",
          field: "guid_aset",
          sortable: false,
        },
        {
          label: "Kolok",
          field: "kolok",
          sortable: false,
        },
        {
          label: "Nalok",
          field: "nalok",
          sortable: false,
        },
        {
          label: "Kobar",
          field: "kobar_108",
          sortable: false,
        },
        {
          label: "Nabar",
          field: "nabar_108",
          sortable: false,
        },
        // {
        //     label: 'Noreg',
        //     field: 'noreg_108',
        //     sortable: false
        // },
        {
          label: "Harga",
          field: "HARGA",
          sortable: false,
        },
        {
          label: "Ukuran",
          field: "UKU_SAT",
          sortable: false,
        },
        // {
        //     label: 'Keberadaan',
        //     field: 'keberadaan',
        //     sortable: false
        // },
        // {
        //     label: 'Wujud',
        //     field: 'wujud_bmd',
        //     sortable: false
        // },
        {
          label: "Status",
          field: "status",
          sortable: false,
        },
        {
          label: "Tanggal Oleh",
          field: "TGLOLEH",
          sortable: false,
        },
      ],
    };
  },
  directives: {
    Ripple,
  },
  props: {
    page: String,
  },
};
</script>

<style lang="scss" scope>
@import "@core/scss/vue/libs/vue-select.scss";
@import "@core/scss/vue/libs/vue-good-table.scss";
</style>